import { CLEAR_PROPOSALINFO, FETCH_PROPOSALINFO } from '../constants/ActionTypes'

import { axios } from 'config/axios'
import { getProposalInfo } from '../api/ispyb.js'

export function fetchProposalInfoAction(user, proposal) {
  return {
    type: FETCH_PROPOSALINFO,
    payload: axios.get(getProposalInfo(user, proposal)),
  }
}

export function clearProposalInfoAction() {
  return {
    type: CLEAR_PROPOSALINFO,
  }
}
